class BaseModel {
    static construct = (fields, data, context = {}) => {
        const constructedObject = {};

        const { useFieldName = false, parseFully = true } = context;

        Object.entries(fields).forEach(([fieldKey, fieldContext]) => {
            if (fieldKey === 'mapper') return;

            const fieldName = useFieldName ? fieldContext.fieldName : fieldKey;

            let fieldValue;

            if (data[fieldName] === undefined) {
                return;
            } else if (data[fieldName] === null) {
                fieldValue = BaseModel.getEmptyValue(fieldContext.type, fieldContext.emptyValue);
            } else {
                if (parseFully && fieldContext.model) {
                    let modelContext = context;

                    if (fieldContext.modelContext) {
                        const modelContextValues = Object.keys(fieldContext.modelContext).reduce(
                            (res, contextFieldKey) => {
                                return {
                                    ...res,
                                    [contextFieldKey]:
                                        constructedObject[
                                            fieldContext.modelContext[contextFieldKey]
                                        ],
                                };
                            },
                            {}
                        );
                        modelContext = { ...modelContext, ...modelContextValues };
                    }

                    if (fieldContext.type === Array) {
                        fieldValue = data[fieldName].map(item =>
                            BaseModel.construct(fieldContext.model, item, modelContext)
                        );
                    } else if (fieldContext.type === Object) {
                        fieldValue = BaseModel.construct(
                            fieldContext.model,
                            data[fieldName],
                            modelContext
                        );
                    }
                } else {
                    fieldValue = data[fieldName];
                }
            }

            constructedObject[fieldKey] = fieldValue;
        });

        return fields.mapper(constructedObject, context);
    };

    static merge = (fields, currentData = {}, newData = {}, context = {}) => {
        const constructedObject = { ...currentData };

        Object.entries(fields).forEach(([fieldKey, fieldContext]) => {
            if (fieldKey === 'mapper') return;

            let fieldValue;

            if (BaseModel.isEmptyValue(newData[fieldKey], fieldContext.type)) {
                return;
            } else {
                if (fieldContext.model) {
                    let modelContext = context;

                    if (fieldContext.modelContext) {
                        const modelContextValues = Object.keys(fieldContext.modelContext).reduce(
                            (res, contextFieldKey) => {
                                return {
                                    ...res,
                                    [contextFieldKey]:
                                        constructedObject[
                                            fieldContext.modelContext[contextFieldKey]
                                        ],
                                };
                            },
                            {}
                        );
                        modelContext = { ...modelContext, ...modelContextValues };
                    }

                    if (fieldContext.type === Array) {
                        fieldValue = newData[fieldKey].map(item =>
                            BaseModel.construct(fieldContext.model, item, modelContext)
                        );
                    } else if (fieldContext.type === Object) {
                        fieldValue = BaseModel.construct(
                            fieldContext.model,
                            newData[fieldKey],
                            modelContext
                        );
                    }
                } else {
                    fieldValue = newData[fieldKey];
                }
            }

            constructedObject[fieldKey] = fieldValue;
        });

        return fields.mapper(constructedObject, context);
    };

    static getEmptyValue = (type, emptyValue) => {
        let fieldValue;

        if (emptyValue !== undefined) {
            return emptyValue;
        }

        switch (type) {
            case Array: {
                fieldValue = [];
                break;
            }
            case Object: {
                fieldValue = {};
                break;
            }
            case Boolean:
            case Number:
            case String: {
                fieldValue = null;
                break;
            }

            default: {
                console.warn(`Data type ${type} is not implemented.`);
            }
        }

        return fieldValue;
    };

    static isEmptyValue = (value, type) => {
        return (
            value === undefined ||
            value === null ||
            (type === Array && value.length === 0) ||
            (type === Object && Object.keys(value).length === 0)
        );
    };
}

export default BaseModel;
